/* Default strings baked into the shared ui/components primitives
 * (tables, selects, dialogs, filters, pickers…). Shared vocabulary such as
 * Cancel/Confirm/Close/Search… lives in common.js. */
const ui = {
  // --- Selects / comboboxes ---------------------------------------------------
  'Select…': 'Pilih…',
  'No matches': 'Tidak ada yang cocok',
  'Remove {label}': 'Hapus {label}',

  // --- DataTable ----------------------------------------------------------------
  'No data': 'Tidak ada data',
  'Sort ascending': 'Urutkan naik',
  'Sort descending': 'Urutkan turun',
  'Select all rows': 'Pilih semua baris',
  'Select row': 'Pilih baris',
  'Filter {column}': 'Filter {column}',
  'Filter column': 'Filter kolom',

  // --- Pagination ------------------------------------------------------------------
  '{start}–{end} of {total}': '{start}–{end} dari {total}',
  'Rows': 'Baris',
  'Rows per page': 'Baris per halaman',
  'Pagination': 'Navigasi halaman',
  'Previous page': 'Halaman sebelumnya',
  'Next page': 'Halaman berikutnya',

  // --- Command palette ------------------------------------------------------------
  'Command palette': 'Palet perintah',
  'Type a command or search…': 'Ketik perintah atau cari…',
  'No results for “{query}”': 'Tidak ada hasil untuk “{query}”',

  // --- Filtering (FilterBar / FilterPopover / FilterDrawer / editors) ---------------
  'Add filter': 'Tambah filter',
  'Remove filter': 'Hapus filter',
  'Back to fields': 'Kembali ke daftar bidang',
  'Filters': 'Filter',
  '{count} active': '{count} aktif',
  'Refine the table': 'Persempit tabel',
  'Clear all': 'Bersihkan semua',
  'Saved views': 'Tampilan tersimpan',
  'Save current': 'Simpan saat ini',
  'All filters': 'Semua filter',
  'Search {field}…': 'Cari {field}…',
  'Filter by {field}…': 'Filter menurut {field}…',
  'Min': 'Min',
  'Max': 'Maks',
  '{count} selected': '{count} dipilih',
  'from {date}': 'dari {date}',
  'until {date}': 'hingga {date}',

  // --- FileUpload --------------------------------------------------------------------
  'Click to upload': 'Klik untuk mengunggah',
  'or drag and drop': 'atau seret dan letakkan',
  'Remove {name}': 'Hapus {name}',

  // --- Date range picker ----------------------------------------------------------------
  'Select dates': 'Pilih tanggal',
  'Select date range': 'Pilih rentang tanggal',
  'Previous month': 'Bulan sebelumnya',
  'Next month': 'Bulan berikutnya',
  'Next 7 days': '7 hari ke depan',
  'January': 'Januari',
  'February': 'Februari',
  'March': 'Maret',
  'April': 'April',
  'May': 'Mei',
  'June': 'Juni',
  'July': 'Juli',
  'August': 'Agustus',
  'September': 'September',
  'October': 'Oktober',
  'November': 'November',
  'December': 'Desember',
  'Mo': 'Sen',
  'Tu': 'Sel',
  'We': 'Rab',
  'Th': 'Kam',
  'Fr': 'Jum',
  'Sa': 'Sab',
  'Su': 'Min',

  // --- Time picker ----------------------------------------------------------------------
  'Select time': 'Pilih waktu',
  'Type a time…': 'Ketik waktu…',
  'No times': 'Tidak ada waktu',

  // --- Number stepper ---------------------------------------------------------------------
  'Decrease': 'Kurangi',
  'Increase': 'Tambah',

  // --- Toast / Banner / PageHeader ----------------------------------------------------------
  'Dismiss notification': 'Tutup notifikasi',
  'Dismiss': 'Tutup',
  'Go back': 'Kembali',
  'Breadcrumb': 'Jejak navigasi',

  // --- FileUpload -------------------------------------------------------------------------
  '{name} is {size} — over the {max} MB limit and was not added.':
    '{name} berukuran {size} — melebihi batas {max} MB dan tidak ditambahkan.',
};

export default ui;
